import { render } from "./Portfolio.vue?vue&type=template&id=cffede44&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=cffede44&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cffede44"

export default script